// Basic colors
const color = {
  white: '#ffffff',
  white60: 'rgba(255, 255, 255, 0.6)',
  white20: 'rgba(255, 255, 255, 0.2)',
  black: '#000000',
  highlight: '#1a84dd',
  inactive: '#656e75',
  border: '#222b32',
};

// Typography values
const typography = {};
typography.family = {
  sansserif: 'Graphik,"Helvetica Neue",Helvetica,Arial,sans-serif',
  proxima: 'proxima-nova,Graphik,"Helvetica Neue",Helvetica,Arial,sans-serif',
  monospace: 'monospace',
};

// Layout values
const layout = {};
layout.breakpoint = {
  tempDesktopXLMin: '2560px',
  tempDesktopLargeMin: '1440px',
  desktopLargeMin: '2220px',
  desktopMax: '2219px',
  desktopMin: '1099px',
  tabletMax: '1098px',
  tabletV2Max: '1024px',
  tabletMin: '768px',
  mobileMax: '767px',
};

// Rem values
const rem = {};
rem.page = {
  maxPlayerWidth: '70.9375rem',
  maxPlayerWidthLarge: '106rem',
  maxWidth: '66.9375rem',
  maxWidthLarge: '130rem',
  sidePadding: '2.5rem',
  headerHeightMobile: '3.8rem',
  headerHeightTablet: '6rem',
  headerHeightDesktop: '4.5625rem',
};

// Exportable theme object
module.exports = {
  theme: 'Fox',
  variables: {
    color,
    typography,
    layout,
    rem,
  },
};
